import { useCallback } from 'react'
import { Keyboard } from 'react-native'
import { useRouter } from 'expo-router'
import { ReduceMotion } from 'react-native-reanimated'
import BottomSheet, { BottomSheetBackdrop } from '@gorhom/bottom-sheet'

import { DS } from '@/design-system'
import JoinGameSheetContent from '@/components/JoinGameSheet/JoinGameSheetContent'
import { styles } from '@/components/JoinGameSheet/styles'
import { isWeb, useMaxWidth } from '@/components/WebWrapper'
import playTabConfig from '@/screens/play-screen/playTabConfig'
import JoinGameSheetContentVariant from '@/components/JoinGameSheet/JoinGameSheetContentVariant'
import { useStore } from '@/models'
import { events } from '@/models/analytics/analytics-events'

export const JoinGameSheet = ({ code }: { code?: string }) => {
  const router = useRouter()
  const maxWidth = useMaxWidth()
  const { analytics } = useStore()

  const onClose = useCallback(() => {
    if (router.canDismiss()) {
      return router.dismiss()
    }
    router.dismissTo('/(root)/(tabs)/play')
  }, [router])

  const renderBackdrop = useCallback(
    (props: React.ComponentProps<typeof BottomSheetBackdrop>) => (
      <BottomSheetBackdrop
        {...props}
        pressBehavior={'close'}
        disappearsOnIndex={-1}
        appearsOnIndex={0}
        onPress={() => {
          requestAnimationFrame(() => {
            Keyboard.dismiss()
          })
        }}
      />
    ),
    []
  )

  return (
    <BottomSheet
      index={0}
      onChange={(index) => index === 0 && analytics.setEvent(events.joinScreen.join_screen_viewed)}
      enableDynamicSizing={true}
      maxDynamicContentSize={500}
      onClose={onClose}
      enableContentPanningGesture
      enableHandlePanningGesture
      enablePanDownToClose
      keyboardBlurBehavior="restore"
      detached={false}
      handleStyle={styles.bottomSheetHandleStyle}
      handleIndicatorStyle={styles.bottomSheetIndicatorStyle}
      backgroundStyle={{ backgroundColor: DS.palette['Brand/Cream'] }}
      backdropComponent={renderBackdrop}
      overrideReduceMotion={ReduceMotion.System}
      style={{
        marginBottom: 64,
        marginHorizontal: isWeb ? 'auto' : undefined,
        maxWidth: maxWidth,
        width: '100%'
      }}
    >
      {playTabConfig.variation === 'variantA' ? (
        <JoinGameSheetContentVariant code={code} />
      ) : (
        <JoinGameSheetContent code={code} />
      )}
    </BottomSheet>
  )
}
